<template>
  <div class="row">
    <vue-tabs direction="horizontal" @tab-change="getTabData">
      <v-tab :title="index" v-for="(chart, index) in chartData" v-bind:key="index">
        <!-- <div class="row">
      <div class="col-md-6">
        <canvas id="area_chart"></canvas>
      </div>
        </div>-->
        <!-- {{(selChart == index)+ '--' +selChart +'--'+ index}} -->
        <div class="row mb5"></div>
        <div class="row" v-if="selChart == index">
          <div class="col-md-6 graph-container">
            <h4 class="heading text-center">Index</h4>
            <div class="row mb5">
              <div class="col-md-4">
                <strong>Min:</strong>
                {{getFixed(chartIndexData.index.min)}}
              </div>
              <div class="col-md-4">
                <strong>Max:</strong>
                {{getFixed(chartIndexData.index.max)}}
              </div>
              <div class="col-md-4">
                <strong>Avg:</strong>
                {{getFixed(chartIndexData.index.avg)}}
              </div>
            </div>
            <!-- <canvas :id="index+'index_chart'"></canvas> -->
            <IndexChart :chartData="chartIndexData.index" :comp="index"/>
          </div>
          <div class="col-md-6 graph-container">
            <!-- <span class="heading">PB</span> -->
            <h4 class="heading text-center">PB</h4>
            <div class="row mb5">
              <div class="col-md-3"></div>
              <div class="col-md-3">
                <strong>Min:</strong>
                {{getFixed(chartIndexData.pb.min)}}
              </div>
              <div class="col-md-3">
                <strong>Max:</strong>
                {{getFixed(chartIndexData.pb.max)}}
              </div>
              <div class="col-md-3">
                <strong>Avg:</strong>
                {{getFixed(chartIndexData.pb.avg)}}
              </div>
            </div>
            <PbChart :chartData="chartIndexData.pb" :comp="index"/>
          </div>
          <div class="col-md-6 graph-container">
            <!-- <span class="heading">PB</span> -->
            <h4 class="heading text-center">PE</h4>
            <div class="row mb5">
              <div class="col-md-3"></div>
              <div class="col-md-3">
                <strong>Min:</strong>
                {{getFixed(chartIndexData.pe.min)}}
              </div>
              <div class="col-md-3">
                <strong>Max:</strong>
                {{getFixed(chartIndexData.pe.max)}}
              </div>
              <div class="col-md-3">
                <strong>Avg:</strong>
                {{getFixed(chartIndexData.pe.avg)}}
              </div>
            </div>
            <PeChart :chartData="chartIndexData.pe" :comp="index"/>
          </div>
          <div class="col-md-6 graph-container">
            <!-- <span class="heading">Div Year Yield</span> -->
            <h4 class="heading text-center">Div Year Yield</h4>
            <div class="row mb5">
              <div class="col-md-3"></div>
              <div class="col-md-3">
                <strong>Min:</strong>
                {{getFixed(chartIndexData.div_year_yield.min)}}
              </div>
              <div class="col-md-3">
                <strong>Max:</strong>
                {{getFixed(chartIndexData.div_year_yield.max)}}
              </div>
              <div class="col-md-3">
                <strong>Avg:</strong>
                {{getFixed(chartIndexData.div_year_yield.avg)}}
              </div>
            </div>
            <DivYieldChart :chartData="chartIndexData.div_year_yield" :comp="index"/>
          </div>
        </div>
      </v-tab>
    </vue-tabs>
  </div>
</template>
<script>
import { Line } from "vue-chartjs";
import http from "@/lib/http";
import IndexChart from "./indices-charts/indexChart.vue";
import PbChart from "./indices-charts/pbChart.vue";
import PeChart from "./indices-charts/peChart.vue";
import DivYieldChart from "./indices-charts/divYieldChart.vue";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { IndexChart, PbChart, PeChart, DivYieldChart },
  extends: Line,
  mixins: [commonMixins],
  props: [], //"chartData", "chartIndexData", "selChart",
  data() {
    return {
      labels: [],
      chdata: [],
      pe_labels: [],
      pe_chdata: [],
      pb_labels: [],
      pb_chdata: [],
      div_labels: [],
      div_chdata: [],
      // selChart: this.selChart,
      // chartIndexData: this.chartIndexData,
      // chartData: this.chartData,
      chartData: [],
      selChart: "",
      chartIndexData: {},
      options: {
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      }
    };
  },
  created() {
    console.log(this.chartData);
    if (this.chartData && this.chartData.length > 0) {
      console.log("chartData Length", this.chartData.length);
      this.setChartData();
    } else {
      this.getChartData();
    }
  },
  methods: {
    getChartData() {
      http.get("getIndustryRatiosForChart", {}, (error, response) => {
        console.log("chartdata", response);
        this.chartData = response;
        console.log("sel chart", Object.keys(this.chartData)[0]);
        this.selChart = Object.keys(this.chartData)[0];
        this.chartIndexData = this.chartData[this.selChart];
        // this.setChartData();
      });
    },
    setChartData() {
      this.chartData[this.selChart].index.series.forEach((val, key) => {
        this.labels.push(val[0].substring(0, val[0].indexOf(" ")));
        this.chdata.push(val[1]);
      });
      this.chartData[this.selChart].pe.series.forEach((val, key) => {
        this.pe_labels.push(val[0].substring(0, val[0].indexOf(" ")));
        this.pe_chdata.push(val[1]);
      });
      this.chartData[this.selChart].pb.series.forEach((val, key) => {
        this.pb_labels.push(val[0].substring(0, val[0].indexOf(" ")));
        this.pb_chdata.push(val[1]);
      });
      this.chartData[this.selChart].div_year_yield.series.forEach(
        (val, key) => {
          this.div_labels.push(val[0].substring(0, val[0].indexOf(" ")));
          this.div_chdata.push(val[1]);
        }
      );
      // this.configureChart();
      console.log("LABELS DATA", this.labels, this.chdata);
    },
    configureChart() {
      console.log("Configure", this.selChart);
      var selchart = this.selChart;
      console.log("selchart", selchart);
      var ctx_index = document
        .getElementById(selchart + "index_chart")
        .getContext("2d");
      var chart = new Chart(ctx_index, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: "transparent",
              borderColor: "#4fabf5",
              pointBackgroundColor: "#ffffff",
              data: this.chdata
            }
          ]
        },
        // Configuration options go here
        options: this.options
      });
      var ctx_pe = document
        .getElementById(selchart + "pe_chart")
        .getContext("2d");
      var chart = new Chart(ctx_pe, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.pe_labels,
          datasets: [
            {
              backgroundColor: "transparent",
              borderColor: "#4dbd74",
              pointBackgroundColor: "#ffffff",
              data: this.pe_chdata
            }
          ]
        },
        // Configuration options go here
        options: this.options
      });
      var ctx_pb = document
        .getElementById(selchart + "pb_chart")
        .getContext("2d");
      var chart = new Chart(ctx_pb, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.pb_labels,
          datasets: [
            {
              label: "",
              backgroundColor: "transparent",
              borderColor: "#5c6bc0",
              pointBackgroundColor: "#ffffff",
              data: this.pb_chdata
            }
          ]
        },
        // Configuration options go here
        options: this.options
      });
      var ctx_div = document
        .getElementById(selchart + "div_chart")
        .getContext("2d");
      var chart = new Chart(ctx_div, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.div_labels,
          datasets: [
            {
              label: "",
              backgroundColor: "transparent",
              borderColor: "#ef5350",
              pointBackgroundColor: "#ffffff",
              data: this.div_chdata
            }
          ]
        },
        // Configuration options go here
        options: this.options
      });
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selChart = newTab.title;
      this.chartIndexData = this.chartData[this.selChart];
    }
  },
  mounted() {
    console.log("Mounted", this.chartData);
    // if (this.chartData.length > 0) this.configureChart();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/indices-data/IndicesChart.vue